import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

export const root = (theme: Theme) => css`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${theme.palette.neutral[300]};

  box-sizing: content-box;
  min-height: 22px;
  padding: 0 0 ${size[4]};

  ${breakpoint.up('md')} {
    min-height: 24px;
    padding: ${size[4]} 0 ${size[8]};
  }
`

export const focused = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.brand[500]};
  box-shadow: 0px 1px 0px 0px ${theme.palette.brand[500]};
`

export const error = (theme: Theme) => css`
  border-bottom-color: ${theme.palette.error[500]};
  box-shadow: 0px 1px 0px 0px ${theme.palette.error[500]};
`

export const borderLess = css`
  border: none;
`

// inner native HTMLInputElement
export const input = (theme: Theme) => css`
  padding: 0;
  width: 100%;
  color: ${theme.palette.neutral[900]};
  caret-color: ${theme.palette.brand[500]};
  border: none;
  background-color: transparent;

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &[type='number']::-webkit-outer-spin-button,
  &[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='password'] {
    letter-spacing: 8px;
  }

  &::placeholder,
  &.empty {
    color: ${theme.palette.neutral[700]};
    font-weight: 400;
  }

  &:disabled {
    opacity: 1; /* required on iOS */
    -webkit-text-fill-color: ${theme.palette
      .neutral[600]}; /* required on iOS */
    color: ${theme.palette.neutral[600]};
  }
`

export const typographyStyles = css`
  /* 16px to prevent ios zooming */
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`

export const adornment = (theme: Theme, disabled: boolean) => css`
  color: ${theme.palette.neutral[!disabled ? 700 : 600]};
`

export const startAdornment = css`
  margin-right: ${size[8]};
`

export const endAdornment = css`
  margin-left: ${size[8]};
`
